import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FileMinus, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { fmtNum, fmtDate } from "../../lib/format";
import { Button } from "../ui/button";

const OPEN = ["BROUILLON", "ENVOYEE", "PARTIELLE", "EN_RETARD"];

// Bandeau « Avoir disponible » sur une facture : imputation en un clic.
export const InvoiceCreditBanner = ({ inv, onApplied }) => {
  const [ncs, setNcs] = useState([]);
  const [busyId, setBusyId] = useState(null);
  const due = Math.round(((Number(inv?.total_ttc) || 0) - (Number(inv?.paid_amount) || 0)) * 100) / 100;
  const open = inv && OPEN.includes(inv.status) && due > 0.004;

  useEffect(() => {
    if (!open) { setNcs([]); return; }
    api.get(`/invoices/${inv.id}/available-credit-notes`).then(({ data }) => setNcs(data || [])).catch(() => setNcs([]));
  }, [inv?.id, inv?.paid_amount, inv?.total_ttc, open]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!open || !ncs.length) return null;
  const apply = async (nc) => {
    setBusyId(nc.id);
    try {
      const amount = Math.min(nc.remaining, due);
      await api.post(`/credit-notes/${nc.id}/apply-to-invoice`, { invoice_id: inv.id, amount });
      toast.success(`Avoir ${nc.reference} imputé : -${fmtNum(amount)} CHF`);
      onApplied();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erreur");
    } finally { setBusyId(null); }
  };
  return (
    <div className="rounded-lg border border-[#E8D5A9] bg-[#FBF4E9] p-4 space-y-2" data-testid="invoice-credit-banner">
      <p className="text-sm font-medium text-[#8C6B2F] flex items-center gap-2"><FileMinus className="w-4 h-4" /> Avoir disponible pour ce client</p>
      {ncs.map((nc) => (
        <div key={nc.id} className="flex items-center justify-between gap-3 flex-wrap text-sm">
          <span>
            <Link to={`/notes-de-credit/${nc.id}`} className="font-mono underline">{nc.reference}</Link>
            <span className="text-[#575A57]"> · {fmtDate(nc.issue_date)} · solde {fmtNum(nc.remaining)} CHF</span>
          </span>
          <Button size="sm" onClick={() => apply(nc)} disabled={!!busyId} className="bg-[#1F4E3D] hover:bg-[#173B2E]" data-testid={`invoice-apply-credit-${nc.id}`}>
            {busyId === nc.id && <Loader2 className="w-4 h-4 mr-1.5 animate-spin" />}
            Imputer {fmtNum(Math.min(nc.remaining, due))} CHF
          </Button>
        </div>
      ))}
    </div>
  );
};

export default InvoiceCreditBanner;
